export default class GalleryImage {

    constructor(data) {
        this.data = data;
        this.display = false;
        this.sourceApplied = false;
        this.loading = false;
        this.isYouTube = false;
        this.youTubeHash = this.getYoutubeHash(this.data.url);
    }

    loadSource(callback = null) {
        if (this.sourceApplied) {
            return;
        }
        this.loading = true;
        this.sourceApplied = true;

        if (this.youTubeHash) {
            this.loadYouTube();
        } else {
            this.loadImage(callback);
        }
    }

    loadYouTube() {
        this.src = 'https://www.youtube.com/embed/' + this.youTubeHash;
        this.loading = false;
        this.show();
    }

    loadImage(callback) {
        let img = new Image();
        img.src = this.data.url;
        img.onload = () => {
            console.log(`image url [${this.data.url}] has been loaded successfully`);
            this.src = this.data.url;
            this.loading = false;
            this.show();
            if (callback) {
                callback();
            }
        }
    }

    show() {
        this.display = true;
    }

    hide() {
        this.display = false;
    }

    getYoutubeHash(url) {
        let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        let match = url.match(regExp);

        if (match && match[7].length == 11) {
            return match[7];
        }

        let imageCheck = /img.youtube.com\/vi\/(.*?)\//;
        match = url.match(imageCheck);

        if (match && match[1].length == 11) {
            return match[1];
        }

        return false;
    }

}
